import App from './components/App.vue'
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { createI18n } from 'vue-i18n'
import { createStore } from 'vuex'
import VTooltip from 'v-tooltip'
import routes from './routes'
import messages from './lang'
import errors from './mixins/errors'
import loadings from './mixins/loadings'
import vuex from './store'

window.axios = require('axios')

window.axios.defaults.baseURL = '/bridge-api'

window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
}

const router = createRouter({
	history: createWebHistory(),
	routes
})

const store = createStore(vuex)

const i18n = createI18n({
	locale: 'pl',
	fallbackLocale: 'en',
	messages
})

createApp(App)
	.use(router)
	.use(i18n)
	.mixin(errors)
	.mixin(loadings)
	.use(VTooltip)
	.use(store)
	.mount('#app')
